import { CountryCode, parsePhoneNumberFromString } from 'libphonenumber-js';

export const parsePhone = (
  phone: string | null | undefined,
  country?: CountryCode
): string => {
  if (!phone) {
    return '';
  }
  const phoneNumber = parsePhoneNumberFromString(phone, country);
  if (phoneNumber) {
    return phoneNumber.format('NATIONAL');
  }
  return '';
};

export const omitString = (text: string, number: number): string => {
  return text.length > number ? text.slice(0, number) + '…' : text;
};

export const formatPhoneNumber = (
  phone: string | null | undefined,
  country?: CountryCode
): string => {
  if (!phone) {
    return '';
  }
  const phoneNumber = parsePhoneNumberFromString(phone, country);

  if (phoneNumber) {
    return phoneNumber.number;
  }

  // 無効な電話番号の場合は元の値を返す（入力途中でも値が消えないように）
  return phone;
};

export const formatByteToMB = (byte: number): number => {
  return Math.ceil((byte / (1024 * 1024)) * 10) / 10;
};

export const formatToHtml = (text: string): string => {
  return text.replace(/\n/g, '<br>');
};

export const removeLastPdfExtension = (s: string): string => {
  if (s.toLowerCase().endsWith('.pdf')) {
    return s.slice(0, -4);
  }
  return s;
};
